import React from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { EditIcon } from '@navi/web-ui/lib/icons';

interface ConfigDrawerHeaderProps {
  isEditable: boolean;
  onEditClick: () => void;
}

const ConfigDrawerHeader: React.FC<ConfigDrawerHeaderProps> = ({ isEditable, onEditClick }) => {
  if (!isEditable) {
    return (
      <div className="flex flex-row items-center">
        <Typography variant="h3">View configuration</Typography>
        <div>
          <Button
            className="ml-20 flex items-center gap-1"
            variant="text"
            onClick={onEditClick}
            startAdornment={<EditIcon color="var(--navi-color-blue-base)" size="sm" />}
          >
            <Typography variant="h3" color="var(--navi-color-blue-base)">
              Edit
            </Typography>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Typography variant="h3" color="var(--navi-color-gray-c1)">
      Edit configuration
    </Typography>
  );
};

export default ConfigDrawerHeader;
